import en from './en'
import es from './es'
import fr from './fr'
import it from './it'

export default { en, es, fr, it }
